export default __webpack_public_path__ + "static/media/Text-field-(3).d74c347b.png";